import Loadable from 'react-loadable';

import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const CreateOrgWithGradProgramPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "userDashboard/CreateOrgWithGradProgramPageContainer" */
      './CreateOrgWithGradProgramPageContainer'
    ),
  loading: LoadableLoadingSection,
});
